document.addEventListener("DOMContentLoaded", function () {
  const categories = document.getElementsByClassName('js-plants-category');
  const isActiveClass = "acc_is-active";
  if (categories) {
    for (let i = 0; i < categories.length; i++) {
      const category = categories[i];
      category.addEventListener('click', function (e) {
        const parent = category.parentNode;
        if (parent.classList.contains(isActiveClass)) {
          parent.classList.remove(isActiveClass);
        } else {
          parent.classList.add(isActiveClass);
        }
      });
    }
  }
});